import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Button,
	Checkbox,
	Divider,
	FormControl,
	Grid,
	IconButton,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useGlobalStyles } from "../../style/GlobalStyle";
import clsx from "clsx";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { FormControlLabel } from "@material-ui/core";
import { useFormik } from "formik";
import DeleteIcon from "@material-ui/icons/Delete";
import { v4 as uuidv4 } from "uuid";
import _ from "lodash";
import BaseDialog from "../genaral-component/BaseDialog";
import { Model } from "../../model/setup-sequelize/Model";
import {
	dataTypesSequelize,
	DATA_TYPES,
} from "../../model/setup-sequelize/DataType";
type Props = {
	isDisplay: boolean;
	item: Model;
	onEdit: (item: Model) => void;
	onCancel: () => void;
};
export default function DialogEditTable(props: Props) {
	const formik = useFormik<Model>({
		initialValues: {} as Model,
		onSubmit: () => {
			props.onEdit(formik.values);
		},
	});

	const addField = () => {
		let fileds = formik.values.fields;
		if (fileds) {
			fileds.push({
				id: uuidv4(),
				modelId: formik.values.id,
				name: "New field",
				type: DATA_TYPES.STRING,
			});
			formik.setValues({
				...formik.values,
				fields: fileds,
			});
		}
	};

	const onChangeCheckedUnique = (value: boolean, index: number) => {
		let fileds = formik.values.fields;
		if (fileds) {
			fileds[index] = {
				...fileds[index],
				unique: value,
			};
			formik.setValues({
				...formik.values,
				fields: fileds,
			});
		}
	};
	const onChangeCheckedPrimary = (value: boolean, index: number) => {
		let fileds = formik.values.fields;
		if (fileds) {
			fileds[index] = {
				...fileds[index],
				primaryKey: value,
			};
			formik.setValues({
				...formik.values,
				fields: fileds,
			});
		}
	};
	const onChangeCheckedRequire = (value: boolean, index: number) => {
		let fileds = formik.values.fields;
		if (fileds) {
			fileds[index] = {
				...fileds[index],
				required: value,
			};
			formik.setValues({
				...formik.values,
				fields: fileds,
			});
		}
	};
	const onChangeDataType = (value: DATA_TYPES, index: number) => {
		let fileds = formik.values.fields;
		if (fileds) {
			fileds[index] = {
				...fileds[index],
				type: value,
			};
			formik.setValues({
				...formik.values,
				fields: fileds,
			});
		}
	};

	useEffect(() => {
		if (props.isDisplay) {
			const valueClone = _.cloneDeep({
				...props.item,
				id: props.item.id || uuidv4(),
				name: props.item.name || "NewTable",
				assocs: props.item.assocs || [],
				fields: props.item.fields || [],
			});
			valueClone.fields = valueClone.fields.map((item) => {
				item.type = item.type || DATA_TYPES.STRING;
				return item;
			});
			formik.setValues(valueClone);
		}
	}, [props]);
	const globalStyles = useGlobalStyles();
	return (
		<Grid>
			<BaseDialog
				isDisplay={props.isDisplay}
				onCancel={props.onCancel}
				onClickConfirm={() => {
					formik.submitForm();
				}}
				title="Edit table"
			>
				<Grid container direction="column" justify="space-around">
					<Grid>
						<TextField
							// variant=""
							label="Name table"
							fullWidth
							name="name"
							onChange={(e) => {
								console.log(e.target.value);
								formik.setValues({
									...formik.values,
									name: e.target.value,
								});
							}}
							value={formik.values.name}
						/>
					</Grid>
					<Divider
						className={clsx(globalStyles.mb2, globalStyles.mt2)}
					/>
					<Grid>
						<Grid>
							<Typography
								variant="h4"
								align="center"
								color="primary"
							>
								Field
							</Typography>
						</Grid>
						{formik.values.fields?.map((item, index) => {
							return (
								<Accordion
								// className={clsx(
								// globalStyles.pp0,
								// globalStyles.mt3
								// )}
								>
									<AccordionSummary
										expandIcon={<ExpandMoreIcon />}
									>
										<Grid container justify="space-between">
											<TextField
												value={item.name}
												variant="standard"
												onClick={(event) =>
													event.stopPropagation()
												}
												onChange={(e) => {
													let fileds =
														formik.values.fields;
													if (fileds) {
														fileds[index] = {
															...fileds[index],
															name:
																e.target.value,
														};
														formik.setValues({
															...formik.values,
															fields: fileds,
														});
													}
												}}
											/>
											<IconButton
												aria-label="delete"
												size="small"
												onClick={(e) => {
													e.stopPropagation();
													let fileds =
														formik.values.fields;
													if (fileds) {
														fileds = fileds.filter(
															(filed) =>
																filed.id !=
																item.id
														);
														formik.setValues({
															...formik.values,
															fields: fileds,
														});
													}
												}}
											>
												<DeleteIcon
													fontSize="small"
													// className={clsx(
													// 	classes.iconAction
													// )}
												/>
											</IconButton>
										</Grid>
									</AccordionSummary>
									<AccordionDetails>
										<Grid container>
											<Grid
												container
												justify="space-between"
											>
												<FormControlLabel
													control={
														<Checkbox
															checked={
																item.primaryKey
															}
															onChange={(
																e,
																value
															) =>
																onChangeCheckedPrimary(
																	value as boolean,
																	index
																)
															}
															name="checkedA"
														/>
													}
													label="Primary Key"
												/>
												<FormControlLabel
													control={
														<Checkbox
															checked={
																item.required
															}
															onChange={(
																e,
																value
															) =>
																onChangeCheckedRequire(
																	value,
																	index
																)
															}
														/>
													}
													label="Required"
												/>
												<FormControlLabel
													control={
														<Checkbox
															checked={
																item.unique
															}
															onChange={(
																e,
																value
															) => {
																onChangeCheckedUnique(
																	value,
																	index
																);
															}}
														/>
													}
													label="Unique"
												/>
											</Grid>
											<Grid xs={12}>
												<FormControl fullWidth>
													<InputLabel>Age</InputLabel>
													<Select
														value={item.type}
														onChange={(e) =>
															onChangeDataType(
																e.target
																	.value as DATA_TYPES,
																index
															)
														}
													>
														{dataTypesSequelize.map(
															(item) => (
																<MenuItem
																	value={item}
																>
																	{item}
																</MenuItem>
															)
														)}
													</Select>
												</FormControl>
											</Grid>
										</Grid>
									</AccordionDetails>
								</Accordion>
							);
						})}
						<Grid>
							<Button
								onClick={(e) => {
									addField();
								}}
								fullWidth
								color="primary"
								variant="contained"
								size="large"
								style={{
									marginTop: 10,
									marginBottom: 10,
									color: "white",
								}}
							>
								addField
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</BaseDialog>
		</Grid>
	);
}
